import logo from './logo.svg';
import './App.css';

import RoutesList from "./routes/RoutesList";
import React, { useEffect } from 'react';


function App() {

  return (
    <React.Fragment>
        <RoutesList />
    </React.Fragment>
  );
}

export default App;
